import { AutoComplete, AutoCompleteProps } from 'antd';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ComponentsDispatch, RootState } from '../store';
import { setterCalendar } from '../store/slices/calendarSlice';
import { ItemTaskType } from '../types';

const CalendarSearch = () => {
    const dispatch = useDispatch<ComponentsDispatch>();
    const tasks = useSelector<RootState, ItemTaskType[]>((state) => state.calendar.tasks);

    const [options, setOptions] = useState<AutoCompleteProps['options']>([]);
    const [value, setValue] = useState<string>();

    const getLabelTask = (task: ItemTaskType) => `${task.name} (${task.datetime})`;

    const onSelect = (data: string) => {
        const newCurrentTask = tasks.find((task) => task.id === data);
        if (newCurrentTask) {
            setValue(getLabelTask(newCurrentTask));
            dispatch(
                setterCalendar({
                    currentTask: newCurrentTask,
                    currentDate: newCurrentTask.datetime,
                }),
            );
        }
    };

    const onSearch = (text: string) => {
        setValue(text);
        let newOptions: { label: string; value: string }[] = [];

        if (text) {
            newOptions = tasks
                .filter((task: ItemTaskType) => getLabelTask(task).toLowerCase().includes(text.toLowerCase()))
                .map((task: ItemTaskType) => ({
                    label: getLabelTask(task),
                    value: task.id,
                }));
        }

        setOptions(newOptions);
    };

    return (
        <AutoComplete
            options={options}
            value={value}
            style={{ width: 200 }}
            onSelect={onSelect}
            onSearch={onSearch}
            placeholder="search"
        />
    );
};

export default CalendarSearch;
